module.exports = __webpack_public_path__ + "img/main_1.7119f87b.jpg";